import { render, staticRenderFns } from "./Chisel48A.vue?vue&type=template&id=3dea9332&scoped=true&"
import script from "./Chisel48A.vue?vue&type=script&lang=js&"
export * from "./Chisel48A.vue?vue&type=script&lang=js&"
import style0 from "./Chisel48A.vue?vue&type=style&index=0&id=3dea9332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea9332",
  null
  
)

export default component.exports